<template lang="pug">
  .spoiler(:class="getClass")
    .spoiler__title(ref="spoiler_title", @click="toggleSpoiler")
      i.icon.icon-spoiler-controller.spoiler__icon
      slot(name="spoiler_title", :isOpened="is_opened")
    .spoiler__content.text(ref="spoiler_content", :style="getStyle")
      slot
</template>

<script>
export default {
  name: "SpoilerItem",

  props: {
    theme: {
      type: String,
      default: "",
    },
    needsJsAnimation: {
      type: Boolean,
      default: false,
    },
    initialState: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      is_opened: this.initialState,
    };
  },

  computed: {
    getClass() {
      return [`spoiler--${this.theme}`, { opened: this.is_opened }];
    },
    getStyle() {
      if (this.needsJsAnimation) {
        const new_height =
          (this.$refs.spoiler_content && this.$refs.spoiler_content.scrollHeight) || 0;

        return { height: this.is_opened ? `${new_height}px` : 0 };
      }

      return {};
    },
  },
  watch: {
    initialState: {
      handler(val) {
        if (val) {
          this.is_opened = val;
        }
      },
      immediate: true,
    },
  },

  methods: {
    toggleSpoiler() {
      this.$emit("spoilerToggled", !this.is_opened);
      return (this.is_opened = !this.is_opened);
    },
  },
};
</script>
